import React from 'react';
import {Form} from 'formik';
import TaskVisit from "../Tasks/TaskVisit";
import Empty from "../../../../common/components/Empty";
import ModalCommon from "../../../../common/components/ModalCommon";
import {taskTypeIDs} from '../../../../common/constants/taskTypes';
import TaskGeneral from "../Tasks/TaskGeneral";
import edit from '../../../../common/assets/edit.svg';
import styles from './styles.module.scss';


const PopupTask = ({
                     taskID,
                     taskTypeID,
                     updateData,
                     formik,
                     handleAction,
                   }) => {
  const getTaskFields = (taskTypeID) => {
    switch (taskTypeID) {
      case taskTypeIDs.visit:
        return <TaskVisit formik={formik}/>
      case taskTypeIDs.general:
        return <TaskGeneral formik={formik}/>
      default:
        return <Empty message={'אין מידע'}/>
    }
  };

  return (
    <ModalCommon
      header={`המשימות - ${taskID}`}
      openButtonLabel={'עריכה'}
      closeButtonLabel={'סגירה'}
      getDataOnOpenModal={() => updateData()}
      handleAction={handleAction}
      disableActionButton={!(formik.isValid && formik.dirty)}
      customModalTrigger={
        <div className={styles.editItemContainer}>
          <img src={edit} alt="edit"/>
          <span className={styles.editItemLabel}>עריכה</span>
        </div>
      }
    >
      <Form>{getTaskFields(taskTypeID)}</Form>
    </ModalCommon>
  );
};

export default PopupTask;
